/**
 * Esegue una funzione dopo threshold [mills].
 * Se viene chiamata più volte prima dell'esecuzione, verrà eseguita solo l'ultima chiamata.
 */
function debounce(func, threshold, execAsap) {
    let timeout;
    return function debounced(...args) {
        const obj = this;
        const delayed = () => {
            if (!execAsap) {
                func.apply(obj, args);
            }
            timeout = null;
        };
        if (timeout) {
            clearTimeout(timeout);
        }
        if (execAsap) {
            func.apply(obj, args);
        }
        timeout = setTimeout(delayed, threshold || 100);
    };
}

export { debounce as default };
